import gql from 'graphql-tag';

export const ProgramEnrollmentSettingsQuery = gql`
  query ProgramEnrollmentSettingsQuery($programId: String!) {
    ProgramEnrollmentSettingsV1Resource {
      byTargetProgram(programId: $programId) {
        elements {
          id
          enrollmentTarget {
            targetProduct {
              ... on ProgramEnrollmentSettingsV1_s12nEnrollmentMember {
                s12nEnrollment {
                  targetS12nId
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GetAllProgramCurriculumContentsQuery = gql`
  query GetAllProgramCurriculumContentsQuery($programIds: [String!]!) {
    EnterpriseProgramsV1Resource {
      multiGet(ids: $programIds) {
        elements {
          id
          curriculumCollections {
            elements {
              id
              courseIds
              s12nIds
            }
          }
        }
      }
    }
  }
`;

export const GetAllProgramDraftStatusesQuery = gql`
  query GetAllProgramDraftStatusesQuery($programIds: [String!]!) {
    EnterpriseProgramDraftsV1Resource {
      multiGet(ids: $programIds) {
        elements {
          id
          status
        }
      }
    }
  }
`;

export const GetBaseCertificateSlugsQuery = gql`
  query GetBaseCertificateSlugsQuery($s12nIds: [String!]!, $limit: Int) {
    OnDemandSpecializationsV1Resource {
      latestInFamiliesWithBaseIdKey(s12nIds: $s12nIds, limit: $limit) {
        elements {
          id
          slug
          launchedAt
        }
      }
    }
  }
`;

export const GetAllContractsForOrgQuery = gql`
  query GetAllContractsForOrgQuery($orgId: String!) {
    EnterpriseUserRostersV1Resource {
      byOrganization(id: $orgId) {
        elements {
          id
          contract {
            id
            contractState
            isReal
          }
          programInvitations(limit: 1) {
            paging {
              total
            }
          }
        }
      }
    }
  }
`;

export const GetProgramContractQuery = gql`
  query GetProgramContractQuery($slug: String!) {
    EnterpriseProgramsV1Resource {
      slug(slug: $slug) {
        elements {
          id
          userRosters {
            elements {
              id
              contractId
              contractTag {
                id
                contractTag
              }
            }
          }
        }
      }
    }
  }
`;
